<template>
    <div class="product__item-grid">
        <vps-upgrade-plan
            v-for="vpsPlan in vpsPlans"
            :key="vpsPlan.name"
            :vpsPlan="vpsPlan"
            :domain="domain"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VpsUpgradePlan from "./VpsUpgradePlan";

export default {
    components: {
        VpsUpgradePlan
    },
    props: {
        domain: String
    },
    computed: {
        ...mapGetters({
            vpsPlans: 'products/vpsPlans'
        })
    },
    methods: {
        changeVpsPlan (VpsPlanName) {
            this.$emit('childToParent', VpsPlanName)
        }
    }
};
</script>
